<template>
  <div class="d-flex justify-content-center">
    <b-popover
      :target="'checkin-history-' + id"
      delay="500"
      triggers="hover"
      placement="bottom"
      custom-class="text-medium"
    >
      <div class="d-flex align-items-center">
        <span :style="circleStyle" class="circle goal-checkin-history-done"></span
        ><span class="pl-2">Check-in on schedule</span>
      </div>
      <div class="d-flex align-items-center">
        <span :style="circleStyle" class="circle goal-checkin-history-not-done"></span
        ><span class="pl-2">Check-in missed</span>
      </div>
      <div class="d-flex align-items-center">
        <span :style="circleStyle" class="circle goal-checkin-history-pending"></span
        ><span class="pl-2">Check-in due</span>
      </div>
    </b-popover>
    <div :id="'checkin-history-' + id" class="d-flex">
      <span
        class="goal-checkin-history-item"
        v-for="history in checkinHistory"
        :key="history.start"
      >
        <span
          v-if="history.events.length > 0"
          :style="circleStyle"
          class="circle goal-checkin-history-done"
        ></span>
        <span
          v-else-if="history.isPast"
          :style="circleStyle"
          class="circle goal-checkin-history-not-done"
        ></span>
        <span v-else :style="circleStyle" class="circle goal-checkin-history-pending"></span>
      </span>
    </div>
  </div>
</template>

<script>
import { BPopover } from 'bootstrap-vue'
import * as R from 'ramda'

/**
 * This component shows the checkin history of a KR
 * It will mark each checkin cycle with a circle
 * - Empty circle signifies checkin is pending for the cycle
 * - Grey circle signifies checkin was missed for the cycle
 * - Green circle signifies that checkin was done for that cycle
 */
export default {
  name: 'CheckinHistory',
  props: {
    /*
    The goal whose checkin history needs to be fetched
     */
    goal: { type: Object },
    /*
    Size of circle
     */
    circleSize: { type: Number, default: 9 },
    /*
    unique identifier - could be goalId
     */
    id: {}
  },
  data() {
    return {
      checkinHistory: []
    }
  },
  components: { BPopover },
  computed: {
    circleStyle() {
      return { width: this.circleSize + 'px', height: this.circleSize + 'px' }
    }
  },
  methods: {
    async refreshCheckinHistory() {
      this.checkinHistory = await this.$store.dispatch('getCheckinHistory', {
        orgId: this.goal.organizationId,
        goalId: this.goal.id
      })
    }
  },
  mounted() {
    this.refreshCheckinHistory()
  },
  watch: {
    goal(newGoal, oldGoal) {
      !R.equals(newGoal, oldGoal) && this.refreshCheckinHistory()
    }
  }
}
</script>

<style lang="scss" scoped>
.circle {
  width: 9px;
  height: 9px;
  border: 1px solid #c4c4c4;
  display: block;
  border-radius: 50%;
}

.goal-checkin-history-item:not(:last-child) {
  margin-right: 4px;
}

.goal-checkin-history-done {
  background-color: #0abe51;
  border-color: #0abe51;
}

.goal-checkin-history-not-done {
  background-color: #c4c4c4;
}

.goal-checkin-history-pending {
  color: #adadad;
}
</style>
